import React, { useState } from 'react';
import { Box, Collapse, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';

import { DropdownMenu } from './HamburgerDropdown';

const useStyle = makeStyles(theme => ({
  iconStyle: {
    color: 'black',
    fontSize: 30,
    position: 'absolute',
    top: 35,
    right: 40,

    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default function ResponsiveMenu() {
  const [clicked, setClicked] = useState(false);
  const classes = useStyle();
  const Icon = !clicked ? MenuIcon : CloseIcon;
  const toggle = () => setClicked(prevClicked => !prevClicked);

  return (
    <>
      <Box>
        <Icon fontSize="large" className={classes.iconStyle} onClick={toggle} />
      </Box>
      <Collapse in={clicked} timeout={500}>
        {clicked && <DropdownMenu />}
      </Collapse>
    </>
  );
}
